import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap } from 'rxjs/operators';

import { ConfirmationModel, DockingBarService } from '@amfam/ui-kit';

import { AnalyticsEventType } from '../+state/quick-quote-feature/quick-quote-enum';
import { QuickQuoteFeatureFacade } from '../+state/quick-quote-feature/quick-quote-feature.facade';
import { QuickQuoteFeatureService } from '../services/quick-quote-feature.service';

@Component({
  selector: 'agent-notification-confirmation',
  templateUrl: './agent-notification-confirmation.component.html',
  styleUrls: ['./agent-notification-confirmation.component.scss'],
  standalone: false
})
export class AgentNotificationConfirmationComponent implements OnInit {
  confirmationData: ConfirmationModel;
  replaceVehicleId$: Observable<string>;
  policyNumberFromVehicle$: Observable<string>;
  showGetAnotherQuote$: Observable<boolean>;

  constructor(
    private quickQuoteFeatureService: QuickQuoteFeatureService,
    private quickQuoteFeatureFacade: QuickQuoteFeatureFacade,
    private router: Router,
    private dockingBarService: DockingBarService
  ) {}

  ngOnInit(): void {
    this.dockingBarService.registerHeading('QUICK QUOTE');
    this.confirmationData = this.quickQuoteFeatureService.getConfirmationData();
    this.replaceVehicleId$ = this.quickQuoteFeatureFacade.replaceVehicleId$;
    this.policyNumberFromVehicle$ = this.quickQuoteFeatureFacade.policyNumberFromVehicle$;
    this.showGetAnotherQuote$ = this.quickQuoteFeatureFacade.errorOnQuickQuote$.pipe(
      tap(err =>
        err
          ? this.quickQuoteFeatureFacade.sendAnalytics(
              AnalyticsEventType.QUICK_QUOTE_AGENT_NOTIFIED
            )
          : this.quickQuoteFeatureFacade.sendAnalytics(
              AnalyticsEventType.QUICK_QUOTE_AGENT_SENT_TO_AGENT
            )
      )
    );
  }

  backToVehicleDetails() {
    this.navigateBackToVehicleDetails();
  }

  getAnotherQuote() {
    this.navigateBackToReplaceVehicle();
  }

  private navigateBackToVehicleDetails() {
    this.policyNumberFromVehicle$
      .pipe(
        filter(policyNumber => !!policyNumber),
        first(),
        tap(policyNumber => this.router.navigateByUrl(`/policies/auto/${policyNumber}`))
      )
      .subscribe();
  }

  private navigateBackToReplaceVehicle() {
    this.quickQuoteFeatureFacade.replaceVehicleId$
      .pipe(
        filter(id => !!id),
        first(),
        tap(() => this.quickQuoteFeatureFacade.resetQuickQuote()),
        tap(id =>
          this.router.navigateByUrl(`/policies/risk-selection/replace-vehicle-quick-quote/${id}`)
        )
      )
      .subscribe();
    this.quickQuoteFeatureFacade.sendAnalytics(
      AnalyticsEventType.BUTTON_AGENT_NOTIFIED_GET_ANOTHER_QUOTE
    );
  }
}
